<template>
	<div id="content" class="no-padding">
		<div class="wrapper">
			<h1>Unsere Leistungen</h1>
			<div class="sections">
				<section>
					<div class="wrapper">
						<h2>KFZ-Reparaturen</h2>
						<p>Fehlerdiagnose und Reparaturen bei Fahrzeugen sämtlicher Fabrikate</p>
					</div>
				</section>
				<section>
					<div class="wrapper">
						<h2>Inspektion</h2>
						<p>kostengünstige Inspektionen, Ölwechsel, Bremsenaustausch uvm.</p>
					</div>
				</section>
				<!-- <section>
					<div class="wrapper">
						<h2>Urlaubs-Check</h2>
						<p>Möchten Sie Ihr Fahrzeug vor Urlauben oder langen Fahrten kostengünstig überprüfen lassen?</p>
					</div>
				</section> -->
				<section>
					<div class="wrapper">
						<h2>TÜV/Hauptuntersuchung</h2>
						<p>TÜV-Nord und Dekra prüfen flexibel direkt vor Ort</p>
					</div>
				</section>
				<section>
					<div class="wrapper">
						<h2>Kaufberatung</h2>
						<p>Untersuchung von Gebrauchtwagen auf Mängel (auch mobil)</p>
					</div>
				</section>
				<section>
					<div class="wrapper">
						<h2>Reifenwechsel und -einlagerung</h2>
						<p>angekündigte Reifentage in jeder Saison</p>
						<!-- <p><router-link to="/contact" class="btn">Termin vereinbaren &rarr;</router-link></p> -->
					</div>
				</section>
				<section>
					<div class="wrapper">
						<h2>Kaufvermittlung</h2>
						<p>Wir suchen ein passendes Fahrzeug für Sie!</p>
					</div>
				</section>
				<section>
					<div class="wrapper">
						<h2>Unfallinstandsetzung</h2>
						<p>professionelle Beseitigung von Unfallschäden in Kooperationen mit KFZ-Lackierbetrieben</p>
					</div>
				</section>
				<!-- <section>
					<div class="wrapper">
						<h2>Restauration</h2>
						<p>hochwertige Restaurationen und Instandsetzungen für Oldtimer</p>
					</div>
				</section> -->
				<section>
					<div class="wrapper">
						<h2>Stellplätze für Autos und Motorräder</h2>
						<p>geschützte Stellplätze zur mittel- oder längerfristigen Unterbringung</p>
					</div>
				</section>
			</div>
			<router-link to="/contact" class="btn full">Termin vereinbaren &rarr;</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Services'
}
</script>

<style lang="scss" scoped>
$base-color: #B10B16;
$background-color: #28373B;

.wrapper {
	padding: 10px;
}
.sections {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-around;
	align-items: stretch;
	align-content: flex-start;
	section {
		margin: 10px;
		margin-left: 0;
		background: $background-color;
		color: #fff;
		flex-grow: 1;
		flex-basis: 25%;
		min-width: 300px;
		transition: .3s transform, .3s box-shadow;
		h1, h2, h3 {
			color: #fff;
			margin: 10px 0;
			padding: 0;
		}

		&:hover {
			transform: translate3d(0,-5px,0);
			box-shadow: 0 5px 10px gray;
		}

		a.btn {
			background: transparent;
			border: 1px solid #fff;
			color: #fff;
			text-align: center;
			display: block;
			width: 100%;
			padding: 5px 25px;
			box-sizing: border-box;
			font-weight: 600;
			text-decoration: none;
			&:hover {
				background: #fff;
				color: $background-color;
			}
		}

	}
}
a.btn.full {
	display: block;
	width: calc(100% - 10px);
	padding: 10px 25px;
	margin: 10px;
	margin-left: 0;
	box-sizing: border-box;
	font-weight: 600;
	text-decoration: none;
	background: $base-color;
	color: #fff;
	border: 1px solid $base-color;
	&:hover {
		background: $background-color;
		border: 1px solid $background-color;
		color: #fff;
	}
}
</style>
